var map = {
	"./badi.mdx": 151,
	"./bindella.mdx": 152,
	"./box.mdx": 51,
	"./burkhalter.mdx": 154,
	"./gastrokultur.mdx": 155,
	"./intro.mdx": 52,
	"./part_1.mdx": 53,
	"./raj.mdx": 157,
	"./sportgastro.mdx": 158,
	"./taberna.mdx": 160,
	"./twospice.mdx": 162,
	"./zfv.mdx": 163
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 150;